import { createReducer } from '@reduxjs/toolkit';

let price = 0;
const gold_price = createReducer(price, {
    'update_price': (state, action) => {
        return action.payload
    }
});

export default gold_price